module.exports = __webpack_public_path__ + "img/bar-chart-03.238cdff8.svg";